import { useEffect } from 'react';
import Languages from './languages.json';

const Translator = () => {    
    useEffect(() => {
        let translatorScript = document.createElement('script');
        translatorScript.setAttribute('src', 'https://cdn.gtranslate.net/widgets/latest/popup.js');
        translatorScript.setAttribute('defer', true);        
        document.body.appendChild(translatorScript);

        let languages = Languages
            .sort((a, b) => a.name > b.name ? 1 : -1)
            .map(x => x.code);
        
        window.gtranslateSettings = {
            "default_language": "en",
            "languages": [...languages],
            "wrapper_selector": ".gtranslate_wrapper",
            "flag_size": 32,
            "flag_style": "3d"
        }
    }, []);

    return (
        <div className="gtranslate_wrapper"></div>
    )
}

export default Translator;